const type = 'RESET_STATE'
const reset = () => ({ type })

const reducer = appReducer => (state, action) => action.type === type
  ? appReducer(undefined, action)
  : appReducer(state, action)

const appResetState = { reducer: reducer, reset: reset }
export default appResetState
